import { jsxs as s, jsx as n } from "react/jsx-runtime";
import { c } from "../clsx-OuTLNxxd.js";
import { B as l } from "../Badge-DIREjShT.js";
import { a as w } from "../Tooltip-cIqqSa8e.js";
import '../Comparison.css';const v = "_comparisonContainer_ah4wq_32", C = "_valuesContainer_ah4wq_41", f = "_value_ah4wq_41", u = "_label_ah4wq_49", q = "_leftBadge_ah4wq_59", $ = "_rightBadge_ah4wq_63", b = "_progressBarContainer_ah4wq_87", N = "_hasMiddleValue_ah4wq_93", A = "_progressBar_ah4wq_87", R = "_leftBar_ah4wq_100", x = "_rightBar_ah4wq_103", y = "_separatorContainer_ah4wq_125", M = "_middleBadge_ah4wq_138", W = "_badgeRightAligned_ah4wq_151", a = {
  comparisonContainer: v,
  valuesContainer: C,
  value: f,
  label: u,
  leftBadge: q,
  rightBadge: $,
  progressBarContainer: b,
  hasMiddleValue: N,
  progressBar: A,
  leftBar: R,
  rightBar: x,
  separatorContainer: y,
  middleBadge: M,
  badgeRightAligned: W
}, j = (o, t = "Comparison") => {
  const i = o.reduce((r, d) => r + d, 0), e = 100;
  return i !== e ? (console.warn(`${t} component: The sum of values must equal ${e}. Current sum: ${i}`), !1) : !0;
}, k = ({
  comparisonLabel: o,
  leftValue: t,
  middleText: i = "DRAW",
  middleValue: e = 0,
  rightValue: r,
  tooltipText: d,
  ...h
}) => {
  if (!j([t, e, r]))
    return null;
  const g = `${t}%`, _ = `${e}%`, m = `${r}%`, p = e > 0, B = e > 0 && r <= 20;
  return /* @__PURE__ */ s(
    "div",
    {
      "aria-label": `${o} comparison bar with ${t}% on the left, ${e}% draw in the middle, and ${r}% on the right.`,
      className: a.comparisonContainer,
      "data-cxy-name": "comparison",
      role: "region",
      ...h,
      children: [
        /* @__PURE__ */ s("div", { className: a.valuesContainer, children: [
          /* @__PURE__ */ n("span", { className: a.value, "data-testid": "comparison-left", children: /* @__PURE__ */ s(l, { className: a.leftBadge, children: [
            t,
            "%"
          ] }) }),
          /* @__PURE__ */ s("div", { className: a.label, children: [
            o,
            " ",
            d && /* @__PURE__ */ n(w, { children: d })
          ] }),
          /* @__PURE__ */ n("span", { className: a.value, "data-testid": "comparison-right", children: /* @__PURE__ */ s(l, { className: a.rightBadge, children: [
            r,
            "%"
          ] }) })
        ] }),
        /* @__PURE__ */ s("div", { className: c(a.progressBarContainer, { [a.hasMiddleValue]: p }), children: [
          /* @__PURE__ */ n(
            "div",
            {
              className: `${a.progressBar} ${a.leftBar}`,
              "data-testid": "comparison-left-bar",
              style: { width: g }
            }
          ),
          /* @__PURE__ */ n(
            "div",
            {
              className: a.separatorContainer,
              "data-testid": "comparison-middle-bar",
              style: {
                width: e ? `${e}%` : void 0
              },
              children: e > 0 && /* @__PURE__ */ s(l, { className: c(a.middleBadge, { [a.badgeRightAligned]: B }), children: [
                i,
                " ",
                _
              ] })
            }
          ),
          /* @__PURE__ */ n(
            "div",
            {
              className: `${a.progressBar} ${a.rightBar}`,
              "data-testid": "comparison-right-bar",
              style: { width: m }
            }
          )
        ] })
      ]
    }
  );
};
export {
  k as Comparison
};
